import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

function Banner() {
  return (
    <div className="banner-area banner-style-two content-right navigation-custom-large zoom-effect overflow-hidden text-light">
      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
        effect="fade"
        className="banner-fade"
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="swiper-slide banner-style-two">
            <div
              className="banner-thumb bg-cover shadow dark"
              style={{ backgroundImage: "url(static/img/banner/1.webp)" }}
            />
            <div className="container">
              <div className="row align-center">
                <div className="col-xl-7 offset-xl-5 col-lg-10 offset-lg-1">
                  <div className="content">
                    <h4>Innovative, Intuitive and Impactful</h4>
                    <h2>
                      <strong>Software That Built </strong>Your Business
                    </h2>
                    <div className="button">
                      <Link
                        className="btn circle btn-gradient btn-md radius animation"
                        to="/contact"
                      >
                        Get Consultation
                      </Link>
                    </div>
                    <div className="shape-circle" />
                  </div>
                </div>
              </div>
            </div>
            {/* Shape */}
            <div className="banner-angle-shape">
              <div
                className="shape-item"
                style={{ backgroundImage: "url(static/img/shape/2.png)" }}
              />
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="swiper-slide banner-style-two">
            <div
              className="banner-thumb bg-cover shadow dark"
              style={{ backgroundImage: "url(static/img/banner/2.webp)" }}
            />
            <div className="container">
              <div className="row align-center">
                <div className="col-xl-7 offset-xl-5 col-lg-10 offset-lg-1">
                  <div className="content">
                    <h4>Turn Clicks Into Clients</h4>
                    <h2>
                      <strong>Smart Marketing Solutions For</strong> Smartest Businesses
                    </h2>
                    <div className="button">
                      <Link
                        className="btn circle btn-gradient btn-md radius animation"
                        to="/contact"
                      >
                        Get Consultation
                      </Link>
                    </div>
                    <div className="shape-circle" />
                  </div>
                </div>
              </div>
            </div>
            <div className="banner-angle-shape">
              <div
                className="shape-item"
                style={{ backgroundImage: "url(static/img/shape/2.png)" }}
              />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Banner;
